var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-progress-linear',{attrs:{"color":"light-blue","height":"10","indeterminate":"","striped":""}}),_c('h3',[_vm._v(_vm._s(_vm.$t("waitingServer")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }